import { call, put } from 'redux-saga/effects';
import { ActionType } from 'deox';

import { handleAPIError } from '@/utils/handle-api-error';
import { createCheckoutSessionAction } from '@/redux/actions/company';
import { createCheckoutSession, TCreateCheckoutSessionResponse } from '@/services/api/company';

export function* createCheckoutSessionSaga(action: ActionType<typeof createCheckoutSessionAction.request>): Generator {
  const { materials, successCallback, failedCallback } = action.payload;
  try {
    const response = yield call(createCheckoutSession, materials);
    const checkoutResponse: TCreateCheckoutSessionResponse = response as TCreateCheckoutSessionResponse;
    yield put(createCheckoutSessionAction.success(checkoutResponse));
    successCallback?.(checkoutResponse);
  } catch (err) {
    // The backend answers 400 with a readable reason - most often that fewer
    // seats were requested than are currently assigned.
    handleAPIError(err, 'Error.createCheckoutSessionError');
    yield put(createCheckoutSessionAction.failure(err));
    failedCallback?.(err);
  }
}
